import { GenIcon } from 'react-icons';
export const MdCurrencyFlagBtc = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'rect',
            attr: {
                x: '2',
                y: '2',
                width: '20',
                height: '20',
                rx: '4',
                fill: '#F7931A',
            },
            child: [],
        },
        {
            tag: 'path',
            attr: {
                d: 'M16.2 10.8c.2-1.3-.8-2-2.1-2.5l.4-1.7-1-.3-.4 1.7c-.3-.1-.5-.1-.8-.2l.4-1.7-1-.2-.4 1.7c-.2-.1-.4-.1-.7-.2l-1.4-.3-.3 1.1s.8.2.7.2c.4.1.5.4.5.6l-.5 2.1c0 0 .1 0 .1 0l-.1 0-.7 2.9c-.1.2-.2.4-.6.3 0 0-.7-.2-.7-.2l-.5 1.1 1.3.3c.2.1.5.1.7.2l-.4 1.7 1 .3.4-1.7c.3.1.5.1.8.2l-.4 1.7 1 .2.4-1.7c1.8.3 3.1.2 3.7-1.4.4-1.3 0-2-.9-2.5.7-.2 1.2-.6 1.3-1.6zm-2.3 3.2c-.3 1.3-2.5.6-3.2.4l.6-2.3c.7.2 2.9.5 2.6 1.9zm.3-3.2c-.3 1.2-2.1.6-2.7.4l.5-2.1c.6.1 2.5.4 2.2 1.7z',
                fill: '#FFFFFF',
            },
            child: [],
        },
    ],
});
